<div *ngIf="catalogDataQuality" class="dq-statistic d-flex flex-column">

  <div class="dq-statistic-header d-flex align-items-center gap-2">
    <span class="dq-statistic-label">{{ 'Details' | translate }}</span>
    <dx-select-box
      class="dq-statistic-select flex-fill"
      [items]="catalogDataQuality.catalogDataQualityTable"
      [(value)]="selectedTable"
      displayExpr="headline"
      [searchEnabled]="false">
    </dx-select-box>
    <dx-button
      *ngIf="!readOnlyUser('dataqualitystatsexport')"
      icon="download"
      stylingMode="text"
      type="default"
      hint="{{ 'Download Details' | translate }}"
      (onClick)="exportDetails()">
    </dx-button>
  </div>

  <div class="dq-statistic-grid-wrap flex-fill">
    <dx-data-grid
      *ngIf="selectedTable"
      class="dq-statistic-grid"
      [dataSource]="selectedTable.lines"
      [showBorders]="false"
      [showColumnLines]="false"
      [rowAlternationEnabled]="true"
      [hoverStateEnabled]="true">

      <dxi-column
        dataField="name"
        caption="{{ 'Regel' | translate }}"
        cellTemplate="nameTpl">
      </dxi-column>
      <div *dxTemplate="let cell of 'nameTpl'">
        <span class="dq-stat-name">{{ cell.text }}</span>
      </div>

      <dxi-column
        dataField="hits"
        [width]="120"
        alignment="right"
        caption="{{ 'Valide Produkte' | translate }}"
        cellTemplate="hitsTpl">
      </dxi-column>
      <div *dxTemplate="let cell of 'hitsTpl'">
        <span class="dq-stat-hits">{{ cell.text }}</span>
      </div>

      <dxi-column
        dataField="total"
        [width]="120"
        alignment="right"
        caption="{{ 'Produkt-Anzahl' | translate }}"
        cellTemplate="totalTpl">
      </dxi-column>
      <div *dxTemplate="let cell of 'totalTpl'">
        <span class="dq-stat-total">{{ cell.text }}</span>
      </div>

      <dxi-column
        dataField="targetType"
        [width]="100"
        caption="{{ 'Angewendet auf' | translate }}"
        cellTemplate="targetTpl">
      </dxi-column>
      <div *dxTemplate="let cell of 'targetTpl'">
        <span class="dq-stat-target">{{ cell.text | translate }}</span>
      </div>

    </dx-data-grid>
  </div>

</div>
